import { render, staticRenderFns } from "./goodsReserveCreateDialog.vue?vue&type=template&id=70bb6122&"
import script from "./goodsReserveCreateDialog.vue?vue&type=script&lang=js&"
export * from "./goodsReserveCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports